import {createSelector} from "reselect";
import {IStore} from "modules/types";
import {parseRequestState} from "modules/utils";

export const getUserState = ({userReducer}: IStore) => userReducer;

export const getIsSessionChecked = createSelector(
	getUserState,
	({sessionCheckedState}) => parseRequestState(sessionCheckedState).isComplete
);

export const getUser = createSelector(getUserState, ({user}) => user);

export const getFormErrors = createSelector(getUserState, ({errors}) => errors);

export const isLoggedIn = createSelector(getUser, (user) => Boolean(user));

export const getProfile = createSelector(getUserState, ({profile}) => profile);

export const getIsLoadingProfile = createSelector(
	getUserState,
	({profileRequestState}) => !parseRequestState(profileRequestState).isComplete
);

export const getIsLoadingSaveProfile = createSelector(
	getUserState,
	({saveProfileRequestState}) => parseRequestState(saveProfileRequestState).isLoading
);
